import {
  SkillsContainer,
  ServicesGrid,
  ServiceCard,
  ServiceIcon,
  ServiceTitle,
  ServiceDescription
} from "./styles";

type Service = {
  icon: string;
  title: string;
  description: string;
};

const services: Service[] = [
  {
    icon: "✨",
    title: "Brand Strategy & Positioning",
    description: "Crafting compelling brand narratives, designing 360° campaigns, and building identities that stand out across competitive markets."
  },
  {
    icon: "📊",
    title: "Digital Strategy & Media Planning",
    description: "Developing data-driven media plans, optimising ad spend, and using analytics tools to maximise campaign performance."
  },
  {
    icon: "📈",
    title: "Performance & Analytics",
    description: "Google Analytics, Meta Business Suite, YouTube Analytics, LinkedIn Campaign Manager, and Google Ads Manager to track, refine, and scale digital performance."
  },
  {
    icon: "🎨",
    title: "Creative Campaign Development",
    description: "Storyboarding, content strategy, and integrated campaign planning for social, video, and digital platforms."
  },
  {
    icon: "🤝",
    title: "Client & Project Management",
    description: "Collaborating with cross-functional teams, leading client communications, and ensuring seamless execution of campaign phases."
  }
];

export function Skills() {
  return (
    <SkillsContainer id="skills">
      <h2>What I Do</h2>
      <ServicesGrid>
        {services.map((service, index) => (
          <ServiceCard key={index}>
            <ServiceIcon>{service.icon}</ServiceIcon>
            <ServiceTitle>{service.title}</ServiceTitle>
            <ServiceDescription>{service.description}</ServiceDescription>
          </ServiceCard>
        ))}
      </ServicesGrid>
    </SkillsContainer>
  );
}
